import Btn from '@app/lui2/Btn';
import AffixContainer from '@app/lui2/Btn/layout/AffixContainer';
import ChildrenContainer from '@app/lui2/Btn/layout/ChildrenContainer';
import TruncatedText from '@app/lui2/text/TruncatedText';
import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

export const RecipientEmail = styled(TruncatedText)`
  font-size: 0.75rem;
  color: ${Luiv3Constants.baseColor['gray-600']};
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.02em;
  width: 100%;
`;

export const RecipientName = styled(TruncatedText)`
  font-size: 0.75rem;
  color: ${Luiv3Constants.baseColor['gray-1000']};
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.02em;
  width: 100%;
`;

export const RecipientTextBlock = styled.div`
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const RecipientRowLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;
  flex: 1;
`;

export const RecipientsTitle = styled.div`
  font-size: 0.75rem;
  color: ${Luiv3Constants.baseColor['gray-1000']};
  font-weight: 700;
  line-height: 1rem;
  letter-spacing: 0.02em;
`;

export const NoRecipients = styled.div`
  color: ${Luiv3Constants.baseColor['gray-600']};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.02em;
`;

export const RecipientRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
`;

export const RecipientBtn = styled(Btn)`
  ${ChildrenContainer} {
    padding-inline-start: 0.5rem;
    font-size: 0.75rem;
  }
  ${AffixContainer} {
    padding-inline-end: 0.5rem;
  }
`;
